import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import { Transition } from 'react-transition-group';
import { useInView } from "react-intersection-observer";
import lazySizes from 'lazysizes';

lazySizes.cfg.preloadAfterLoad = false;
lazySizes.cfg.expFactor = 2;
lazySizes.cfg.expand = 300;
lazySizes.cfg.loadMode = 1;

const AnimationLTR = keyframes`
  0%{
    width: 0;
    left: 0;
  }
  65%{
    width: 100%;
    left: 0;
  }
  100% {
    width: 0;
    left: 100%;
  }
`;
const AnimationPicture = keyframes`
  0% {
    opacity: 0;
  }
  65% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
export const PictureWrapper = styled.div`
  position: relative;
  height: inherit;
  
  img {
    display:block;
    max-width: 100%;
  }
    
  &:before, &:after {
    content: '';
    position: absolute; 
    top: 0;
    right: 0;
    height: 100%;
    z-index: 10;
  }
  &:before {
    background-color: #202020;
  }

  picture {
    transition: all 0.5s ease;
  }

  ${(props) => props.state === 'entering' && css`
    &:before {
      // animation: none;
    }
    & picture {
      opacity: 0;
      transform: scale(1.5);
      // animation: none;
    }
  `}
  ${(props) => props.state === 'entered' && css`
    &:before {
      // animation: ${AnimationLTR} 1s ease;
    }
    & picture {
      opacity: 1;
      transform: scale(1);
      // animation: ${AnimationPicture} 1s ease;
    }
  `}
  ${(props) => props.state === 'exiting' && css`
    &:before {
      // animation: ${AnimationLTR} 1s ease;
    }
    & picture {
      opacity: 1;
      transform: scale(1);
      // animation: ${AnimationPicture} 1s ease;
    }
  `}
  ${(props) => props.state === 'exited' && css`
    &:before {
      // animation: none;
    }
    & picture {
      opacity: 0;
      transform: scale(1.5);
      // animation: none;
    }
  `}
`;

const Picture = (props) => {
  const { alt, defaultSource, sources } = props;
  const [ref, inView] = useInView();

  // if (webP) {
  //     /** @todo implement sources update instead
  //      * https://css-tricks.com/using-webp-images/#article-header-id-3
  //      */
  //     // webPSources = sources.map((source, index) => {
  //     //   return source.srcset = '';
  //     // });
  // }

  const renderSources = sources ? sources.map((source, index) => {
      return <source key={index}
          media={source.media}
          data-srcset={source.srcset}
          sizes={source.sizes}
          type={source.type}
      />
  }) : '';

  return <Transition appear={true}
                     in={inView}
                     timeout={250}
  >
      {(state) => (
      <PictureWrapper ref={ref} state={state}>
          <picture>
              {renderSources}
              <img className="lazyload" alt={alt} data-src={defaultSource} />
          </picture>
      </PictureWrapper>
      )}
  </Transition>;
}

export default Picture;
